// @flow

import React from 'react';
import Tabs from 'react-aaui/lib/tabs';
import L10nMessage from 'react-aaui/lib/shared/L10nMessage';

import './ParticipantResultsTab.scss';
import SplitResults from '../SplitResults/SplitResults';
import SummaryResults from '../SummaryResults/SummaryResults';

const ParticipantResultsTab = ({
  isLive,
  isTriathlon,
}: { isLive: boolean, isTriathlon: boolean }) => {
  const defaultTab = isTriathlon ? 'summary' : 'splits';

  return (
    <Tabs
      className="participant-result-tab"
      defaultSelected={defaultTab}>
      <Tabs.Header>
        {
          isTriathlon
            ? <Tabs.Title name="summary">
              <L10nMessage id="page.participant.summaryTab" />
            </Tabs.Title> : null
        }
        <Tabs.Title name="splits">
          <L10nMessage id="page.participant.splitTab" />
          {
            isLive
              ? <span className="participant-result-tab__tag">
                <L10nMessage id="page.participant.splitTab.live" />
              </span> : ''
          }
        </Tabs.Title>
      </Tabs.Header>
      {
        isTriathlon
          ? <Tabs.Container name="summary">
            <SummaryResults isLive={isLive} />
          </Tabs.Container> : null
      }
      <Tabs.Container name="splits">
        <SplitResults />
      </Tabs.Container>
    </Tabs>
  );
};

export default ParticipantResultsTab;
